<ng-container *ngIf="showNewConversationModal">
    <p-dialog
        [header]="'ui.action_bars.create_conversation.new_conversation' | translate"
        [(visible)]="showNewConversationModal"
        [modal]="true"
        [style]="{width: '540px'}"
        [baseZIndex]="10000"
        [draggable]="false"
        [resizable]="false"
    >
    <p-header>
        <div class="dialog-header">
          {{'ui.action_bars.create_conversation.new_conversation' | translate}}
        </div>
      </p-header>
        <new-conversation [practice]="(practice$ | async) || undefined" (conversationCreated)="handleConversationCreated()" (closed)="handleNewConversationClosed()"></new-conversation>
        <div class="bottom-row">
          <div class="left"></div>
          <div class="center">
            <ng-container *ngIf="(embedMode$ | ngrxPush) === false">
              <a [href]="helpLink + '/digital-practice/en/articles/11631629-how-do-i-add-a-new-template-to-my-digital-practice'" target="_blank">
                <img src="/assets/images/icons/question_mark.png" height="20" class="help-icon" alt="">{{'ui.action_bars.create_conversation.need_help' | translate}}
              </a>
            </ng-container>
          </div>
          <div class="right"></div>
        </div>
    </p-dialog>
</ng-container>

<p-button (click)="openNewConversationModal()" styleClass="p-button-fifth p-button-fullwidth p-button-center p-button-hide-label">
    <img alt="logo" class="icon" src="/assets/images/icons/ticket-white.svg" />
    <span class="p-ml-2">{{'ui.action_bars.create_conversation.new_conversation' | translate}}</span>
</p-button>
